import { PlatformSections, defaultPlatformContent } from "@quintara/site-kit";
import { usePageMeta } from "../usePageMeta";
import { useCmsContent } from "../useCmsContent";

export function Platform() {
  const content = useCmsContent("platform", defaultPlatformContent);
  usePageMeta(content.meta.title, content.meta.description);
  return <PlatformSections content={content} />;
}
